import { SingleLabelGroup, LabelGroups } from '@/routes/settings/labels/types/label.ts'
import { create } from 'zustand'

const EMPTY_LABEL_GROUP = {
  name: undefined,
  labels: [],
  id: undefined,
}

export type LabelGroupsState = {
  labelGroups: LabelGroups | null
  setLabelGroups: (labelGroups: LabelGroups | null) => void
  addNewLabelGroup: () => void
  changeLastLabelGroup: (labelGroup: SingleLabelGroup) => void
  deleteLastLabelGroup: () => void
  currentlyEditedLabelId: number | null
  setCurrentlyEditedLabelId: (id: number | null) => void
}

export const useAllLabelGroupStore = create<LabelGroupsState>((set, get) => ({
  labelGroups: null,
  setLabelGroups: labelGroups => {
    set({
      labelGroups,
    })
  },
  addNewLabelGroup: () => {
    const { labelGroups } = get()
    const members = labelGroups?.['hydra:member'] || []
    if (members.length === 0 || members[members.length - 1].id !== undefined) {
      const newMembers = [...members, { ...EMPTY_LABEL_GROUP }]
      set({
        labelGroups: {
          ...labelGroups,
          'hydra:member': newMembers as SingleLabelGroup[],
        },
      })
    }
  },
  changeLastLabelGroup: (labelGroup: SingleLabelGroup) => {
    const { labelGroups } = get()
    const members = labelGroups?.['hydra:member'] || []
    if (members.length === 0) return

    const newMembers = [...members.slice(0, -1), labelGroup]

    set({
      labelGroups: {
        ...labelGroups,
        'hydra:member': newMembers,
      },
    })
  },
  deleteLastLabelGroup: () => {
    const { labelGroups } = get()
    const members = labelGroups?.['hydra:member'] || []
    if (members.length === 0) return

    const newMembers = members.slice(0, -1)

    set({
      labelGroups: {
        ...labelGroups,
        'hydra:member': newMembers,
      },
    })
  },
  currentlyEditedLabelId: null,
  setCurrentlyEditedLabelId: id => set({ currentlyEditedLabelId: id }),
}))
